package com.schoolconnect.app.feature.home

import androidx.compose.foundation.background
import androidx.compose.foundation.BorderStroke
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.BoxWithConstraints
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.IntrinsicSize
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.RowScope
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxHeight
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.heightIn
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.layout.widthIn
import androidx.compose.foundation.rememberScrollState
import androidx.compose.foundation.verticalScroll
import androidx.compose.foundation.shape.CircleShape
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.Card
import androidx.compose.material3.CardDefaults
import androidx.compose.material3.HorizontalDivider
import androidx.compose.material3.Icon
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.OutlinedButton
import androidx.compose.material3.Text
import com.schoolconnect.app.designsystem.list.DesktopAwareLazyColumn
import com.schoolconnect.app.designsystem.AppBrandWordmark
import com.schoolconnect.app.designsystem.AppPageHeader
import com.schoolconnect.app.designsystem.AppPageSubtitle
import androidx.compose.animation.core.LinearEasing
import androidx.compose.animation.core.RepeatMode
import androidx.compose.animation.core.animateFloat
import androidx.compose.animation.core.infiniteRepeatable
import androidx.compose.animation.core.rememberInfiniteTransition
import androidx.compose.animation.core.tween
import androidx.compose.runtime.Composable
import androidx.compose.runtime.DisposableEffect
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.geometry.Offset
import androidx.compose.ui.graphics.Brush
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.ImageBitmap
import androidx.compose.ui.layout.ContentScale
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.style.TextOverflow
import androidx.compose.ui.unit.Dp
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import kotlinx.coroutines.delay
import com.schoolconnect.app.feature.calendar.CalendarScreen
import com.schoolconnect.app.feature.reports.StaffPerformanceReportsScreen
import com.schoolconnect.app.feature.calendar.CalendarUiEvent
import com.schoolconnect.app.feature.calendar.CalendarUiState
import com.schoolconnect.app.feature.calendar.CalendarViewModel
import com.schoolconnect.app.feature.attendance.AttendanceScreen
import com.schoolconnect.app.feature.attendance.AttendanceViewModel
import com.schoolconnect.app.feature.homework.HomeworkScreen
import com.schoolconnect.app.feature.homework.HomeworkViewModel
import com.schoolconnect.app.feature.exams.ExamsScreen
import com.schoolconnect.app.feature.exams.ExamsViewModel
import com.schoolconnect.app.feature.notices.NoticesScreen
import com.schoolconnect.app.feature.notices.NoticesViewModel
import com.schoolconnect.app.feature.quickannouncements.QuickAnnouncementsScreen
import com.schoolconnect.app.feature.quickannouncements.QuickAnnouncementsViewModel
import com.schoolconnect.app.feature.eventsnews.EventsNewsScreen
import com.schoolconnect.app.feature.eventsnews.EventsNewsViewModel
import com.schoolconnect.app.feature.parentnotes.ParentNotesScreen
import com.schoolconnect.app.feature.parentnotes.ParentNotesViewModel
import com.schoolconnect.app.feature.timetable.TimeTableScreen
import com.schoolconnect.app.feature.timetable.TeacherTimeTableScreen
import com.schoolconnect.app.feature.timetable.TimeTableUiEvent
import com.schoolconnect.app.feature.timetable.TimeTableUiState
import com.schoolconnect.app.feature.timetable.TimeTableViewModel
import com.schoolconnect.app.feature.classes.ClassesScreen
import com.schoolconnect.app.feature.classes.ClassesUiEvent
import com.schoolconnect.app.feature.classes.ClassesUiState
import com.schoolconnect.app.feature.classes.ClassesViewModel
import com.schoolconnect.app.feature.common.FeatureEntry
import com.schoolconnect.app.feature.common.ShellTopRightActions
import com.schoolconnect.app.feature.common.ShellPageHeader
import com.schoolconnect.app.feature.common.shellAvatarInitials
import com.schoolconnect.app.designsystem.list.AdminListStatCardShell
import com.schoolconnect.app.feature.imports.ImportsUiEvent
import com.schoolconnect.app.feature.imports.ImportsUiState
import com.schoolconnect.app.feature.imports.ImportsScreen
import com.schoolconnect.app.feature.imports.ImportsViewModel
import com.schoolconnect.app.feature.studentenrollment.StudentEnrollmentScreen
import com.schoolconnect.app.feature.studentenrollment.StudentEnrollmentUiEvent
import com.schoolconnect.app.feature.studentenrollment.StudentEnrollmentUiState
import com.schoolconnect.app.feature.studentenrollment.StudentEnrollmentViewModel
import com.schoolconnect.app.feature.students.StudentsScreen
import com.schoolconnect.app.feature.students.StudentsUiEvent
import com.schoolconnect.app.feature.students.StudentsUiState
import com.schoolconnect.app.feature.students.StudentsViewModel
import com.schoolconnect.app.feature.mystudents.TeacherMyStudentsScreen
import com.schoolconnect.app.feature.mystudents.TeacherMyStudentsViewModel
import com.schoolconnect.app.feature.parents.ParentsScreen
import com.schoolconnect.app.feature.parents.ParentsUiEvent
import com.schoolconnect.app.feature.parents.ParentsUiState
import com.schoolconnect.app.feature.parents.ParentsViewModel
import com.schoolconnect.app.feature.rolepicker.RolePickerDialog
import com.schoolconnect.app.feature.staff.StaffContent
import com.schoolconnect.app.feature.staff.StaffViewModel
import com.schoolconnect.app.feature.subjects.SubjectsScreen
import com.schoolconnect.app.feature.subjects.SubjectsUiEvent
import com.schoolconnect.app.feature.subjects.SubjectsUiState
import com.schoolconnect.app.feature.subjects.SubjectsViewModel
import com.schoolconnect.app.feature.classconversations.ClassConversationsScreen
import com.schoolconnect.app.feature.classconversations.AdminClassConversationsApiScreen
import com.schoolconnect.app.feature.classconversations.ClassConversationsUiState
import com.schoolconnect.app.feature.classconversations.ClassConversationsViewModel
import com.schoolconnect.app.feature.documents.DocumentLibraryScreen
import com.schoolconnect.app.feature.documents.DocumentLibraryViewModel
import com.schoolconnect.app.feature.support.SupportCenterScreen
import com.schoolconnect.app.designsystem.list.AdminListPanelHeader
import com.schoolconnect.app.designsystem.list.AdminListEmptyState
import com.schoolconnect.app.datasource.network.UserSessionStore
import com.schoolconnect.app.domain.SchoolKeys
import ischoolconnect.sharedui.generated.resources.Res
import ischoolconnect.sharedui.generated.resources.building_school
import ischoolconnect.sharedui.generated.resources.ic_launcher
import org.jetbrains.compose.resources.painterResource
import com.schoolconnect.app.util.decodeImageBitmap

private val SchoolAdminBg = Color(0xFFF7FAFF)
private val SchoolAdminNavy = Color(0xFF0A1446)
private val SchoolAdminBlue = Color(0xFF2563EB)
private val SchoolAdminBorder = Color(0xFFE5E7EB)
private val SchoolAdminCard = Color.White
private val SchoolAdminMuted = Color(0xFF5C678C)

@Composable
internal fun SchoolAdminHomeScreen(
    state: HomeUiState,
    features: List<FeatureEntry>,
    onEvent: (HomeUiEvent) -> Unit,
    onOpenFeature: (String) -> Unit,
    onToggleTheme: () -> Unit,
    onLogout: () -> Unit,
    onEditProfile: () -> Unit
) {
    val selectedNavId = state.selectedNavId

    // Feature ViewModels start their API work from init. Keep each one out of
    // the composition until the school admin actually opens that rail item.
    val importsViewModel = if (selectedNavId == "school-setup") {
        remember(state.railActivationKey, state.schoolId, state.schoolCode) {
            ImportsViewModel(
                schoolCode = state.schoolCode,
                schoolId = state.schoolId,
                currentUserId = UserSessionStore.getUserId()
            )
        }
    } else null
    val importsUiState by (importsViewModel?.uiState?.collectAsState()
        ?: remember { mutableStateOf(ImportsUiState()) })

    val studentEnrollmentViewModel = if (selectedNavId == "student-enrollment") {
        remember(state.railActivationKey, state.schoolId, state.schoolCode) {
            StudentEnrollmentViewModel(
                schoolCode = state.schoolCode,
                schoolId = state.schoolId,
                currentUserId = UserSessionStore.getUserId()
            )
        }
    } else null
    val studentEnrollmentUiState by (studentEnrollmentViewModel?.uiState?.collectAsState()
        ?: remember { mutableStateOf(StudentEnrollmentUiState()) })

    val studentsViewModel = if (selectedNavId == "student-records") {
        remember(state.railActivationKey, state.schoolId) { StudentsViewModel() }
    } else null
    val studentsUiState by (studentsViewModel?.uiState?.collectAsState()
        ?: remember { mutableStateOf(StudentsUiState()) })

    val classesViewModel = if (selectedNavId == "classes") {
        remember(state.railActivationKey, state.schoolId) { ClassesViewModel() }
    } else null
    val classesUiState by (classesViewModel?.uiState?.collectAsState()
        ?: remember { mutableStateOf(ClassesUiState()) })

    val subjectsViewModel = if (selectedNavId == "subjects") {
        remember(state.railActivationKey, state.schoolId) { SubjectsViewModel() }
    } else null
    val subjectsUiState by (subjectsViewModel?.uiState?.collectAsState()
        ?: remember { mutableStateOf(SubjectsUiState()) })

    val parentsViewModel = if (selectedNavId == "parents") {
        remember(state.railActivationKey, state.schoolId) { ParentsViewModel() }
    } else null
    val parentsUiState by (parentsViewModel?.uiState?.collectAsState()
        ?: remember { mutableStateOf(ParentsUiState()) })

    val calendarViewModel = if (selectedNavId == "calendar") {
        remember(state.railActivationKey, state.schoolId, state.activeAcademicYearId) { CalendarViewModel(state.activeAcademicYearId) }
    } else null
    val calendarUiState by (calendarViewModel?.uiState?.collectAsState()
        ?: remember { mutableStateOf(CalendarUiState()) })

    val timeTableViewModel = if (selectedNavId == "time-table-import") {
        remember(state.railActivationKey, state.schoolId) { TimeTableViewModel(state.schoolId) }
    } else null
    val timeTableUiState by (timeTableViewModel?.uiState?.collectAsState()
        ?: remember { mutableStateOf(TimeTableUiState()) })

    DisposableEffect(
        importsViewModel,
        studentEnrollmentViewModel,
        studentsViewModel,
        classesViewModel,
        subjectsViewModel,
        parentsViewModel,
        calendarViewModel,
        timeTableViewModel
    ) {
        onDispose {
            importsViewModel?.clear()
            studentEnrollmentViewModel?.clear()
            studentsViewModel?.clear()
            classesViewModel?.clear()
            subjectsViewModel?.clear()
            parentsViewModel?.clear()
            calendarViewModel?.clear()
            timeTableViewModel?.clear()
        }
    }
    val headerActions: @Composable RowScope.() -> Unit = {
        ShellTopRightActions(
            roleLabel = state.roleLabel,
            roleSubtitle = state.roleSubtitle,
            initials = shellAvatarInitials(state.userProfile.fullName.ifBlank { state.roleLabel }),
            expanded = state.isAccountMenuExpanded,
            onExpandedChange = { expanded ->
                onEvent(
                    if (expanded) {
                        HomeUiEvent.AccountMenuToggled
                    } else {
                        HomeUiEvent.AccountMenuDismissed
                    }
                )
            },
            onChangeRole = { onEvent(HomeUiEvent.RolePickerRequested) },
            onLogout = onLogout,
            onMyProfile = onEditProfile,
            profileName = state.userProfile.fullName,
            profileEmail = state.userProfile.email
        )
    }

    val content = remember(
        state.selectedNavId,
        state.schoolStatistics,
        state.schoolDashboardEventsNotices,
        state.activeAcademicYearLabel,
        state.isActiveAcademicYearLoading
    ) {
        val activeAcademicYearDisplayLabel = state.activeAcademicYearLabel.ifBlank {
            if (state.isActiveAcademicYearLoading) {
                "Loading current academic year..."
            } else {
                "Current academic year unavailable"
            }
        }
        HomeDefaults.schoolAdminDashboardContent(
            selectedNavId = state.selectedNavId,
            academicYearLabel = activeAcademicYearDisplayLabel,
            statistics = state.schoolStatistics,
            eventsNotices = state.schoolDashboardEventsNotices
        )
    }
    BoxWithConstraints(
        modifier = Modifier
            .fillMaxSize()
            .background(SchoolAdminBg)
    ) {
        val compact = maxWidth < 1120.dp
        if (compact) {
            SchoolAdminCompactLayout(
                state = state,
                content = content,
                features = features,
                onEvent = onEvent,
                onOpenFeature = onOpenFeature,
                onToggleTheme = onToggleTheme,
                onLogout = onLogout,
                importsUiState = importsUiState,
                onImportsEvent = { event -> importsViewModel?.onEvent(event) },
                studentEnrollmentUiState = studentEnrollmentUiState,
                onStudentEnrollmentEvent = { event -> studentEnrollmentViewModel?.onEvent(event) },
                studentsUiState = studentsUiState,
                onStudentsEvent = { event -> studentsViewModel?.onEvent(event) },
                classesUiState = classesUiState,
                onClassesEvent = { event -> classesViewModel?.onEvent(event) },
                subjectsUiState = subjectsUiState,
                onSubjectsEvent = { event -> subjectsViewModel?.onEvent(event) },
                parentsUiState = parentsUiState,
                onParentsEvent = { event -> parentsViewModel?.onEvent(event) },
                calendarUiState = calendarUiState,
                onCalendarEvent = { event -> calendarViewModel?.onEvent(event) },
                timeTableUiState = timeTableUiState,
                onTimeTableEvent = { event -> timeTableViewModel?.onEvent(event) },
                headerActions = headerActions,
                onEditProfile = onEditProfile
            )
        } else {
            SchoolAdminDesktopLayout(
                state = state,
                content = content,
                features = features,
                onEvent = onEvent,
                onOpenFeature = onOpenFeature,
                onToggleTheme = onToggleTheme,
                onLogout = onLogout,
                maxWidth = maxWidth,
                importsUiState = importsUiState,
                onImportsEvent = { event -> importsViewModel?.onEvent(event) },
                studentEnrollmentUiState = studentEnrollmentUiState,
                onStudentEnrollmentEvent = { event -> studentEnrollmentViewModel?.onEvent(event) },
                studentsUiState = studentsUiState,
                onStudentsEvent = { event -> studentsViewModel?.onEvent(event) },
                classesUiState = classesUiState,
                onClassesEvent = { event -> classesViewModel?.onEvent(event) },
                subjectsUiState = subjectsUiState,
                onSubjectsEvent = { event -> subjectsViewModel?.onEvent(event) },
                parentsUiState = parentsUiState,
                onParentsEvent = { event -> parentsViewModel?.onEvent(event) },
                calendarUiState = calendarUiState,
                onCalendarEvent = { event -> calendarViewModel?.onEvent(event) },
                timeTableUiState = timeTableUiState,
                onTimeTableEvent = { event -> timeTableViewModel?.onEvent(event) },
                headerActions = headerActions,
                onEditProfile = onEditProfile
            )
        }

        if (state.rolePicker.isVisible) {
            RolePickerDialog(
                state = state.rolePicker,
                onOptionSelected = { onEvent(HomeUiEvent.RolePickerSelectionChanged(it.id)) },
                onRememberSelectionChanged = { onEvent(HomeUiEvent.RolePickerRememberChanged(it)) },
                onContinueClicked = { onEvent(HomeUiEvent.RolePickerContinueClicked) },
                onCloseClicked = { onEvent(HomeUiEvent.RolePickerClosed) }
            )
        }

    }
}

@Composable
private fun SchoolAdminDesktopLayout(
    state: HomeUiState,
    content: SchoolAdminDashboardContent,
    features: List<FeatureEntry>,
    onEvent: (HomeUiEvent) -> Unit,
    onOpenFeature: (String) -> Unit,
    onToggleTheme: () -> Unit,
    onLogout: () -> Unit,
    maxWidth: Dp,
    importsUiState: ImportsUiState,
    onImportsEvent: (ImportsUiEvent) -> Unit,
    studentEnrollmentUiState: StudentEnrollmentUiState,
    onStudentEnrollmentEvent: (StudentEnrollmentUiEvent) -> Unit,
    studentsUiState: StudentsUiState,
    onStudentsEvent: (StudentsUiEvent) -> Unit,
    classesUiState: ClassesUiState,
    onClassesEvent: (ClassesUiEvent) -> Unit,
    subjectsUiState: SubjectsUiState,
    onSubjectsEvent: (SubjectsUiEvent) -> Unit,
    parentsUiState: ParentsUiState,
    onParentsEvent: (ParentsUiEvent) -> Unit,
    calendarUiState: CalendarUiState,
    onCalendarEvent: (CalendarUiEvent) -> Unit,
    timeTableUiState: TimeTableUiState,
    onTimeTableEvent: (TimeTableUiEvent) -> Unit,
    headerActions: @Composable RowScope.() -> Unit,
    onEditProfile: () -> Unit
) {
    Row(modifier = Modifier.fillMaxSize()) {
        SchoolAdminSidebarPanel(
            state = state,
            content = content,
            features = features,
            onEvent = onEvent,
            onOpenFeature = onOpenFeature,
            modifier = Modifier
                .width(if (state.isSidebarCollapsed) 72.dp else 280.dp)
                .fillMaxHeight()
        )
        SchoolAdminMainContent(
            state = state,
            content = content,
            onEvent = onEvent,
            onToggleTheme = onToggleTheme,
            onLogout = onLogout,
            onEditProfile = onEditProfile,
            importsUiState = importsUiState,
            onImportsEvent = onImportsEvent,
            studentEnrollmentUiState = studentEnrollmentUiState,
            onStudentEnrollmentEvent = onStudentEnrollmentEvent,
            studentsUiState = studentsUiState,
            onStudentsEvent = onStudentsEvent,
            classesUiState = classesUiState,
            onClassesEvent = onClassesEvent,
            subjectsUiState = subjectsUiState,
            onSubjectsEvent = onSubjectsEvent,
            parentsUiState = parentsUiState,
            onParentsEvent = onParentsEvent,
            calendarUiState = calendarUiState,
            onCalendarEvent = onCalendarEvent,
            timeTableUiState = timeTableUiState,
            onTimeTableEvent = onTimeTableEvent,
            headerActions = headerActions,
            compactLayout = false,
            modifier = Modifier.weight(1f),
            contentWidth = if (maxWidth > 1480.dp) 1160.dp else 1080.dp
        )
    }
}

@Composable
private fun SchoolAdminCompactLayout(
    state: HomeUiState,
    content: SchoolAdminDashboardContent,
    features: List<FeatureEntry>,
    onEvent: (HomeUiEvent) -> Unit,
    onOpenFeature: (String) -> Unit,
    onToggleTheme: () -> Unit,
    onLogout: () -> Unit,
    importsUiState: ImportsUiState,
    onImportsEvent: (ImportsUiEvent) -> Unit,
    studentEnrollmentUiState: StudentEnrollmentUiState,
    onStudentEnrollmentEvent: (StudentEnrollmentUiEvent) -> Unit,
    studentsUiState: StudentsUiState,
    onStudentsEvent: (StudentsUiEvent) -> Unit,
    classesUiState: ClassesUiState,
    onClassesEvent: (ClassesUiEvent) -> Unit,
    subjectsUiState: SubjectsUiState,
    onSubjectsEvent: (SubjectsUiEvent) -> Unit,
    parentsUiState: ParentsUiState,
    onParentsEvent: (ParentsUiEvent) -> Unit,
    calendarUiState: CalendarUiState,
    onCalendarEvent: (CalendarUiEvent) -> Unit,
    timeTableUiState: TimeTableUiState,
    onTimeTableEvent: (TimeTableUiEvent) -> Unit,
    headerActions: @Composable RowScope.() -> Unit,
    onEditProfile: () -> Unit
) {
    Column(modifier = Modifier.fillMaxSize()) {
        SchoolAdminCompactTopBar(
            state = state,
            content = content,
            onEvent = onEvent,
            onLogout = onLogout,
            onEditProfile = onEditProfile,
            showGreeting = state.selectedNavId != "parents"
        )
        SchoolAdminMainContent(
            state = state,
            content = content,
            onEvent = onEvent,
            onToggleTheme = onToggleTheme,
            onLogout = onLogout,
            onEditProfile = onEditProfile,
            importsUiState = importsUiState,
            onImportsEvent = onImportsEvent,
            studentEnrollmentUiState = studentEnrollmentUiState,
            onStudentEnrollmentEvent = onStudentEnrollmentEvent,
            studentsUiState = studentsUiState,
            onStudentsEvent = onStudentsEvent,
            classesUiState = classesUiState,
            onClassesEvent = onClassesEvent,
            subjectsUiState = subjectsUiState,
            onSubjectsEvent = onSubjectsEvent,
            parentsUiState = parentsUiState,
            onParentsEvent = onParentsEvent,
            calendarUiState = calendarUiState,
            onCalendarEvent = onCalendarEvent,
            timeTableUiState = timeTableUiState,
            onTimeTableEvent = onTimeTableEvent,
            headerActions = headerActions,
            compactLayout = true,
            modifier = Modifier.weight(1f),
            contentWidth = 1120.dp
        )
    }
}

@Composable
private fun SchoolAdminSidebarPanel(
    state: HomeUiState,
    content: SchoolAdminDashboardContent,
    features: List<FeatureEntry>,
    onEvent: (HomeUiEvent) -> Unit,
    onOpenFeature: (String) -> Unit,
    modifier: Modifier = Modifier
) {
    val schoolAdminGroups = listOf(
        NavGroup(
            label = "Bulk Import",
            items = listOf(
                NavItem("school-setup", "Staff & Academic Setup", "cloud_upload", isActive = state.selectedNavId == "school-setup"),
                NavItem("student-enrollment", "Students & Parents", "user_plus", isActive = state.selectedNavId == "student-enrollment"),
                NavItem("calendar", "Calendar Import", "calendar", isActive = state.selectedNavId == "calendar"),
                NavItem("time-table-import", "Time Table Import", "clock", isActive = state.selectedNavId == "time-table-import")
            )
        ),
        NavGroup(
            label = "Manage Records",
            items = listOf(
                NavItem("subjects", "Subjects", "document", isActive = state.selectedNavId == "subjects"),
                NavItem("classes", "Classes & Sections", "book", isActive = state.selectedNavId == "classes"),
                NavItem("staff", "Staff", "school_users", isActive = state.selectedNavId == "staff"),
                NavItem("student-records", "Student Records", "graduation_cap", isActive = state.selectedNavId == "student-records"),
                NavItem("parents", "Parent Records", "users", isActive = state.selectedNavId == "parents")
            )
        ),
    )
    val teacherRailContent = HomeDashboardContent(
        navGroups = HomeDefaults.teacherNavGroups(
            selectedNavId = state.selectedNavId,
            studentTitle = "Students"
        ),
        metrics = emptyList(),
        recentActivities = emptyList(),
        healthEntries = emptyList()
    )
    TeacherSidebarPanel(
        content = teacherRailContent,
        state = state,
        onEvent = onEvent,
        onOpenFeature = onOpenFeature,
        administrationGroups = schoolAdminGroups,
        modifier = modifier
    )
}

@Composable
private fun SchoolAdminRailBrand(
    schoolName: String,
    academicYearLabel: String,
    schoolLogoBytes: ByteArray? = null,
    isSchoolLogoLoading: Boolean = false,
    compact: Boolean
) {
    val schoolLogo: ImageBitmap? = remember(schoolLogoBytes) {
        schoolLogoBytes?.let(::decodeImageBitmap)
    }
    if (compact) {
        Box(
            modifier = Modifier
                .size(56.dp)
                .clip(RoundedCornerShape(20.dp))
                .background(SchoolAdminBlue.copy(alpha = 0.08f)),
            contentAlignment = Alignment.Center
        ) {
            if (isSchoolLogoLoading) {
                SchoolAdminRailBrandShimmer(compact = true)
            } else if (schoolLogo != null) {
                androidx.compose.foundation.Image(
                    bitmap = schoolLogo,
                    contentDescription = schoolName,
                    contentScale = ContentScale.Crop,
                    modifier = Modifier.size(34.dp).clip(CircleShape)
                )
            } else {
                Icon(
                    painter = painterResource(Res.drawable.building_school),
                    contentDescription = schoolName,
                    tint = SchoolAdminBlue,
                    modifier = Modifier.size(34.dp)
                )
            }
        }
    } else {
        Column(
            modifier = Modifier
                .fillMaxWidth()
                .padding(horizontal = 12.dp, vertical = 6.dp),
            verticalArrangement = Arrangement.spacedBy(10.dp)
        ) {
            Row(
                verticalAlignment = Alignment.CenterVertically,
                horizontalArrangement = Arrangement.spacedBy(12.dp)
            ) {
                Box(
                    modifier = Modifier
                        .size(52.dp)
                        .clip(RoundedCornerShape(16.dp))
                        .background(SchoolAdminBlue.copy(alpha = 0.08f)),
                    contentAlignment = Alignment.Center
                ) {
                    if (isSchoolLogoLoading) {
                        SchoolAdminRailBrandShimmer(compact = false)
                    } else if (schoolLogo != null) {
                        androidx.compose.foundation.Image(
                            bitmap = schoolLogo,
                            contentDescription = schoolName,
                            contentScale = ContentScale.Crop,
                            modifier = Modifier.size(52.dp).clip(RoundedCornerShape(16.dp))
                        )
                    } else {
                        Icon(
                            painter = painterResource(Res.drawable.building_school),
                            contentDescription = schoolName,
                            tint = SchoolAdminBlue,
                            modifier = Modifier.size(30.dp)
                        )
                    }
                }
                Column(verticalArrangement = Arrangement.spacedBy(3.dp)) {
                    if (isSchoolLogoLoading) {
                        SchoolAdminRailBrandShimmer(width = 150.dp, height = 22.dp)
                    } else {
                        Text(
                            text = schoolName,
                            style = MaterialTheme.typography.titleLarge,
                            color = SchoolAdminNavy,
                            fontWeight = FontWeight.Bold,
                            maxLines = 2,
                            overflow = TextOverflow.Ellipsis
                        )
                    }
                }
            }
            if (isSchoolLogoLoading) {
                SchoolAdminRailBrandShimmer(width = 92.dp, height = 16.dp)
            } else {
                Text(
                    text = academicYearLabel,
                    style = MaterialTheme.typography.titleSmall,
                    color = SchoolAdminNavy,
                    fontWeight = FontWeight.SemiBold
                )
            }
            HorizontalDivider(color = SchoolAdminBorder)
        }
    }
}

@Composable
private fun SchoolAdminRailBrandShimmer(compact: Boolean = false) {
    val transition = rememberInfiniteTransition(label = "school_admin_logo_shimmer")
    val shimmerX by transition.animateFloat(
        initialValue = -120f,
        targetValue = 220f,
        animationSpec = infiniteRepeatable(
            animation = tween(durationMillis = 1100, easing = LinearEasing),
            repeatMode = RepeatMode.Restart
        ),
        label = "school_admin_logo_shimmer_x"
    )
    val brush = Brush.linearGradient(
        colors = listOf(Color(0xFFE6ECF8), Color(0xFFF8FAFF), Color(0xFFE6ECF8)),
        start = Offset(shimmerX, 0f),
        end = Offset(shimmerX + 120f, 120f)
    )
    Box(
        modifier = Modifier
            .size(if (compact) 34.dp else 42.dp)
            .clip(if (compact) CircleShape else RoundedCornerShape(12.dp))
            .background(brush)
    )
}

@Composable
private fun SchoolAdminRailBrandShimmer(width: Dp, height: Dp) {
    val transition = rememberInfiniteTransition(label = "school_admin_brand_text_shimmer")
    val shimmerX by transition.animateFloat(
        initialValue = -180f,
        targetValue = 220f,
        animationSpec = infiniteRepeatable(
            animation = tween(durationMillis = 1100, easing = LinearEasing),
            repeatMode = RepeatMode.Restart
        ),
        label = "school_admin_brand_text_shimmer_x"
    )
    val brush = Brush.linearGradient(
        colors = listOf(Color(0xFFE6ECF8), Color(0xFFF8FAFF), Color(0xFFE6ECF8)),
        start = Offset(shimmerX, 0f),
        end = Offset(shimmerX + 120f, 40f)
    )
    Box(
        modifier = Modifier
            .width(width)
            .height(height)
            .clip(RoundedCornerShape(6.dp))
            .background(brush)
    )
}

@Composable
private fun SchoolAdminRailFooter(
    compact: Boolean,
    onToggleCollapse: () -> Unit
) {
    Column(
        verticalArrangement = Arrangement.spacedBy(if (compact) 8.dp else 10.dp),
        modifier = Modifier.fillMaxWidth()
    ) {
        Row(
            modifier = Modifier
                .fillMaxWidth()
                .clip(RoundedCornerShape(16.dp))
                .background(Color.White)
                .padding(horizontal = if (compact) 8.dp else 10.dp, vertical = if (compact) 8.dp else 10.dp),
            horizontalArrangement = if (compact) Arrangement.Center else Arrangement.spacedBy(10.dp),
            verticalAlignment = Alignment.CenterVertically
        ) {
            Icon(
                painter = painterResource(Res.drawable.ic_launcher),
                contentDescription = "iConnect.School",
                tint = Color.Unspecified,
                modifier = Modifier.size(if (compact) 24.dp else 28.dp)
            )
            if (!compact) {
                AppBrandWordmark(
                    style = MaterialTheme.typography.bodyLarge,
                    fontWeight = FontWeight.SemiBold
                )
            }
        }

        if (compact) {
            Box(
                modifier = Modifier
                    .fillMaxWidth()
                    .clip(RoundedCornerShape(12.dp))
                    .clickable(onClick = onToggleCollapse)
                    .padding(horizontal = 8.dp, vertical = 10.dp),
                contentAlignment = Alignment.Center
            ) {
                Icon(
                    painter = homeIconPainter("chevron_right"),
                    contentDescription = null,
                    tint = SchoolAdminNavy,
                    modifier = Modifier.size(18.dp)
                )
            }
        } else {
            Row(
                modifier = Modifier
                    .fillMaxWidth()
                    .clip(RoundedCornerShape(12.dp))
                    .clickable(onClick = onToggleCollapse)
                    .padding(horizontal = 10.dp, vertical = 8.dp),
                horizontalArrangement = Arrangement.spacedBy(10.dp),
                verticalAlignment = Alignment.CenterVertically
            ) {
                Icon(
                    painter = homeIconPainter("chevron_left"),
                    contentDescription = null,
                    tint = SchoolAdminNavy,
                    modifier = Modifier.size(18.dp)
                )
                Text(
                    text = "Collapse Menu",
                    style = MaterialTheme.typography.bodyMedium,
                    fontWeight = FontWeight.SemiBold,
                    color = SchoolAdminNavy
                )
            }
        }
    }
}

@Composable
private fun SchoolAdminSidebarNavItem(
    item: NavItem,
    compact: Boolean,
    onClick: () -> Unit
) {
    SidebarNavItem(
        item = item,
        compact = compact,
        onClick = onClick
    )
}

@Composable
private fun SchoolAdminExpandableGroup(
    title: String,
    icon: String,
    compact: Boolean,
    expanded: Boolean,
    onToggleExpanded: () -> Unit,
    children: List<NavItem>,
    onItemClick: (NavItem) -> Unit
) {
    Column(verticalArrangement = Arrangement.spacedBy(if (compact) 8.dp else 10.dp)) {
        if (!compact) {
            Row(
                modifier = Modifier
                    .fillMaxWidth()
                    .clip(RoundedCornerShape(12.dp))
                    .clickable(onClick = onToggleExpanded)
                    .padding(horizontal = 12.dp, vertical = 12.dp),
                verticalAlignment = Alignment.CenterVertically,
                horizontalArrangement = Arrangement.spacedBy(12.dp)
            ) {
                Icon(
                    painter = homeIconPainter(icon),
                    contentDescription = null,
                    tint = SchoolAdminNavy,
                    modifier = Modifier.size(20.dp)
                )
                Text(
                    text = title,
                    style = MaterialTheme.typography.bodyLarge,
                    fontWeight = FontWeight.SemiBold,
                    color = SchoolAdminNavy,
                    modifier = Modifier.weight(1f)
                )
                Icon(
                    painter = homeIconPainter("chevron_down"),
                    contentDescription = if (expanded) "Collapse $title" else "Expand $title",
                    tint = SchoolAdminNavy,
                    modifier = Modifier
                        .size(18.dp)
                        .clip(RoundedCornerShape(4.dp))
                )
            }
        }

        if (expanded || compact) {
            Column(
                verticalArrangement = Arrangement.spacedBy(if (compact) 4.dp else 6.dp),
                modifier = Modifier.padding(start = if (compact) 0.dp else 12.dp)
            ) {
                children.forEach { child ->
                    SchoolAdminSidebarNavItem(
                        item = child,
                        compact = compact,
                        onClick = { onItemClick(child) }
                    )
                }
            }
        }
    }
}

@Composable
private fun SchoolAdminCompactTopBar(
    state: HomeUiState,
    content: SchoolAdminDashboardContent,
    onEvent: (HomeUiEvent) -> Unit,
    onLogout: () -> Unit,
    onEditProfile: () -> Unit,
    showGreeting: Boolean
) {
    Column(
        modifier = Modifier
            .fillMaxWidth()
            .background(Color.White)
            .padding(horizontal = 18.dp, vertical = 14.dp)
    ) {
        Row(
            modifier = Modifier.fillMaxWidth(),
            verticalAlignment = Alignment.Top
        ) {
            if (showGreeting) {
                Column(
                    modifier = Modifier.weight(1f),
                    verticalArrangement = Arrangement.spacedBy(8.dp)
                ) {
                    Text(
                        text = "Hello, ${state.userProfile.fullName.ifBlank { state.roleLabel }}",
                        style = MaterialTheme.typography.headlineMedium,
                        fontWeight = FontWeight.Bold,
                        color = AppPageHeader,
                        maxLines = 1,
                        overflow = TextOverflow.Ellipsis
                    )
                    Text(
                        text = "${state.schoolLabel}  |  ${content.academicYearLabel}",
                        style = MaterialTheme.typography.bodyMedium,
                        color = AppPageSubtitle,
                        fontWeight = FontWeight.SemiBold,
                        maxLines = 1,
                        overflow = TextOverflow.Ellipsis
                    )
                }
            } else {
                Spacer(modifier = Modifier.weight(1f))
            }
            ShellTopRightActions(
                roleLabel = state.roleLabel,
                roleSubtitle = state.roleSubtitle,
                initials = shellAvatarInitials(state.userProfile.fullName.ifBlank { state.roleLabel }),
                expanded = state.isAccountMenuExpanded,
                onExpandedChange = { expanded ->
                    onEvent(if (expanded) HomeUiEvent.AccountMenuToggled else HomeUiEvent.AccountMenuDismissed)
                },
                onChangeRole = { onEvent(HomeUiEvent.RolePickerRequested) },
                onLogout = onLogout,
                onMyProfile = onEditProfile,
                profileName = state.userProfile.fullName,
                profileEmail = state.userProfile.email,
                forceCompact = true
            )
        }
    }
}

@Composable
private fun SchoolAdminMainContent(
    state: HomeUiState,
    content: SchoolAdminDashboardContent,
    onEvent: (HomeUiEvent) -> Unit,
    onToggleTheme: () -> Unit,
    onLogout: () -> Unit,
    onEditProfile: () -> Unit,
    importsUiState: ImportsUiState,
    onImportsEvent: (ImportsUiEvent) -> Unit,
    studentEnrollmentUiState: StudentEnrollmentUiState,
    onStudentEnrollmentEvent: (StudentEnrollmentUiEvent) -> Unit,
    studentsUiState: StudentsUiState,
    onStudentsEvent: (StudentsUiEvent) -> Unit,
    classesUiState: ClassesUiState,
    onClassesEvent: (ClassesUiEvent) -> Unit,
    subjectsUiState: SubjectsUiState,
    onSubjectsEvent: (SubjectsUiEvent) -> Unit,
    parentsUiState: ParentsUiState,
    onParentsEvent: (ParentsUiEvent) -> Unit,
    calendarUiState: CalendarUiState,
    onCalendarEvent: (CalendarUiEvent) -> Unit,
    timeTableUiState: TimeTableUiState,
    onTimeTableEvent: (TimeTableUiEvent) -> Unit,
    headerActions: @Composable RowScope.() -> Unit,
    compactLayout: Boolean,
    modifier: Modifier = Modifier,
    contentWidth: Dp
) {
    val teacherTimeTableViewModel = if (state.selectedNavId == "time-table") {
        remember(state.railActivationKey, state.schoolId, state.activeAcademicYearId) {
            com.schoolconnect.app.feature.timetable.TeacherTimeTableViewModel(
                roleCode = state.roleCode,
                schoolId = state.schoolId,
                academicYearId = state.activeAcademicYearId
            )
        }
    } else null
    val teacherTimeTableUiState by (teacherTimeTableViewModel?.uiState?.collectAsState()
        ?: remember { mutableStateOf(com.schoolconnect.app.feature.timetable.TeacherTimeTableUiState()) })
    DisposableEffect(teacherTimeTableViewModel) { onDispose { teacherTimeTableViewModel?.clear() } }

    val teacherMyStudentsViewModel = if (state.selectedNavId == "students") {
        remember(state.railActivationKey, state.schoolId) { TeacherMyStudentsViewModel() }
    } else null
    val teacherMyStudentsUiState by (teacherMyStudentsViewModel?.uiState?.collectAsState()
        ?: remember { mutableStateOf(com.schoolconnect.app.feature.mystudents.MyStudentsUiState()) })
    DisposableEffect(teacherMyStudentsViewModel) {
        onDispose { teacherMyStudentsViewModel?.clear() }
    }

    val documentLibraryViewModel = if (state.selectedNavId == "document-library") {
        remember(state.railActivationKey, state.schoolId) { DocumentLibraryViewModel(state.schoolId) }
    } else null
    val documentLibraryUiState by (documentLibraryViewModel?.uiState?.collectAsState()
        ?: remember { mutableStateOf(com.schoolconnect.app.feature.documents.DocumentLibraryUiState()) })
    DisposableEffect(documentLibraryViewModel) {
        onDispose { documentLibraryViewModel?.clear() }
    }
    val classConversationsViewModel = if (state.selectedNavId == "class-conversations") {
        remember(state.railActivationKey, state.schoolId) { ClassConversationsViewModel(schoolId = state.schoolId) }
    } else null
    val classConversationsUiState by (classConversationsViewModel?.uiState?.collectAsState()
        ?: remember { mutableStateOf(ClassConversationsUiState()) })
    DisposableEffect(classConversationsViewModel) {
        onDispose { classConversationsViewModel?.close() }
    }
    val attendanceViewModel = if (state.selectedNavId == "attendance") {
        remember(state.railActivationKey, state.schoolId) {
            AttendanceViewModel(schoolId = state.schoolId)
        }
    } else null
    val attendanceUiState by (attendanceViewModel?.uiState?.collectAsState()
        ?: remember { mutableStateOf(com.schoolconnect.app.feature.attendance.AttendanceUiState()) })
    val homeworkViewModel = if (state.selectedNavId == "homework") {
        remember(state.railActivationKey, state.schoolId) { HomeworkViewModel(schoolId = state.schoolId) }
    } else null
    val homeworkUiState by (homeworkViewModel?.uiState?.collectAsState()
        ?: remember { mutableStateOf(com.schoolconnect.app.feature.homework.HomeworkUiState()) })
    val examsViewModel = if (state.selectedNavId == "exams") {
        remember(state.railActivationKey, state.schoolId) { ExamsViewModel() }
    } else null
    val examsUiState by (examsViewModel?.uiState?.collectAsState()
        ?: remember { mutableStateOf(com.schoolconnect.app.feature.exams.ExamsUiState()) })
    val noticesViewModel = if (state.selectedNavId == "notices") {
        remember(state.railActivationKey, state.schoolId) { NoticesViewModel() }
    } else null
    val noticesUiState by (noticesViewModel?.uiState?.collectAsState()
        ?: remember { mutableStateOf(com.schoolconnect.app.feature.notices.NoticesUiState()) })
    val quickAnnouncementsViewModel = if (state.selectedNavId == "quick-announcements") {
        remember(state.railActivationKey, state.schoolId) { QuickAnnouncementsViewModel() }
    } else null
    val quickAnnouncementsUiState by (quickAnnouncementsViewModel?.uiState?.collectAsState()
        ?: remember { mutableStateOf(com.schoolconnect.app.feature.quickannouncements.QuickAnnouncementsUiState()) })
    val eventsNewsViewModel = if (state.selectedNavId == "events-news") {
        remember(state.railActivationKey, state.schoolId) { EventsNewsViewModel(state.schoolId) }
    } else null
    val eventsNewsUiState by (eventsNewsViewModel?.uiState?.collectAsState()
        ?: remember { mutableStateOf(com.schoolconnect.app.feature.eventsnews.EventsNewsUiState()) })
    val parentNotesViewModel = if (state.selectedNavId == "parent-notes") {
        remember(state.railActivationKey, state.schoolId) { ParentNotesViewModel(state.schoolId) }
    } else null
    val parentNotesUiState by (parentNotesViewModel?.uiState?.collectAsState()
        ?: remember { mutableStateOf(com.schoolconnect.app.feature.parentnotes.ParentNotesUiState()) })
    DisposableEffect(
        attendanceViewModel,
        homeworkViewModel,
        examsViewModel,
        noticesViewModel,
        quickAnnouncementsViewModel,
        eventsNewsViewModel,
        parentNotesViewModel
    ) {
        onDispose {
            attendanceViewModel?.clear()
            homeworkViewModel?.clear()
            examsViewModel?.clear()
            noticesViewModel?.clear()
            quickAnnouncementsViewModel?.clear()
            eventsNewsViewModel?.clear()
            parentNotesViewModel?.clear()
        }
    }
    if (state.selectedNavId == "attendance") {
        Box(modifier = modifier.fillMaxSize()) {
            AttendanceScreen(
                state = attendanceUiState,
                onEvent = attendanceViewModel?.let { it::onEvent } ?: {},
                onBack = { onEvent(HomeUiEvent.NavSelected("dashboard")) },
                shellRoleCode = state.roleCode,
                shellSchoolLabel = state.schoolLabel,
                onChangeRole = { onEvent(HomeUiEvent.RolePickerRequested) },
                onLogout = onLogout
            )
        }
        return
    }
    if (state.selectedNavId == "homework") {
        Box(modifier = modifier.fillMaxSize()) {
            HomeworkScreen(
                state = homeworkUiState,
                onEvent = homeworkViewModel?.let { it::onEvent } ?: {},
                onBack = { onEvent(HomeUiEvent.NavSelected("dashboard")) },
                shellRoleCode = state.roleCode,
                shellSchoolLabel = state.schoolLabel,
                onChangeRole = { onEvent(HomeUiEvent.RolePickerRequested) },
                onLogout = onLogout
            )
        }
        return
    }
    if (state.selectedNavId == "exams") {
        Box(modifier = modifier.fillMaxSize()) {
            ExamsScreen(
                state = examsUiState,
                onEvent = examsViewModel?.let { it::onEvent } ?: {},
                onBack = { onEvent(HomeUiEvent.NavSelected("dashboard")) },
                shellRoleCode = state.roleCode,
                shellSchoolLabel = state.schoolLabel,
                onChangeRole = { onEvent(HomeUiEvent.RolePickerRequested) },
                onLogout = onLogout
            )
        }
        return
    }
    if (state.selectedNavId == "quick-announcements") {
        Box(modifier = modifier.fillMaxSize()) {
            QuickAnnouncementsScreen(
                state = quickAnnouncementsUiState,
                onEvent = quickAnnouncementsViewModel?.let { it::onEvent } ?: {},
                shellRoleCode = state.roleCode,
                onChangeRole = { onEvent(HomeUiEvent.RolePickerRequested) },
                onLogout = onLogout,
                onBack = { onEvent(HomeUiEvent.NavSelected("dashboard")) }
            )
        }
        return
    }
    if (state.selectedNavId == "notices") {
        Box(modifier = modifier.fillMaxSize()) {
            NoticesScreen(
                state = noticesUiState,
                onEvent = noticesViewModel?.let { it::onEvent } ?: {},
                onBack = { onEvent(HomeUiEvent.NavSelected("dashboard")) },
                shellRoleCode = state.roleCode,
                onChangeRole = { onEvent(HomeUiEvent.RolePickerRequested) },
                onLogout = onLogout
            )
        }
        return
    }
    if (state.selectedNavId == "parent-notes") {
        Box(modifier = modifier.fillMaxSize()) {
            ParentNotesScreen(
                state = parentNotesUiState,
                onEvent = parentNotesViewModel?.let { it::onEvent } ?: {},
                onBack = { onEvent(HomeUiEvent.NavSelected("dashboard")) },
                shellRoleCode = state.roleCode,
                shellSchoolLabel = state.schoolLabel,
                onChangeRole = { onEvent(HomeUiEvent.RolePickerRequested) },
                onLogout = onLogout
            )
        }
        return
    }
    if (state.selectedNavId == "events-news") {
        Box(modifier = modifier.fillMaxSize()) {
            EventsNewsScreen(
                state = eventsNewsUiState,
                onEvent = eventsNewsViewModel?.let { it::onEvent } ?: {},
                onBack = { onEvent(HomeUiEvent.NavSelected("dashboard")) },
                shellRoleCode = state.roleCode,
                onChangeRole = { onEvent(HomeUiEvent.RolePickerRequested) },
                onLogout = onLogout
            )
        }
        return
    }
    var showProfileShimmer by remember(state.schoolId) { mutableStateOf(true) }
    LaunchedEffect(state.schoolId, state.userProfile.isLoading) {
        if (state.userProfile.isLoading) {
            showProfileShimmer = true
        } else {
            // Keep the skeleton visible briefly even when the profile is served
            // from cache, so the loading transition is perceptible and stable.
            delay(300)
            showProfileShimmer = false
        }
    }

    val scrollState = rememberScrollState()
    if (state.selectedNavId == "staff") {
        val staffViewModel = remember(state.railActivationKey, state.schoolId) { StaffViewModel(schoolId = state.schoolId) }
        val staffUiState by staffViewModel.uiState.collectAsState()
        DisposableEffect(staffViewModel) {
            onDispose { staffViewModel.clear() }
        }
        Box(
            modifier = modifier.fillMaxSize()
        ) {
            StaffContent(
                state = staffUiState,
                onEvent = staffViewModel::onEvent,
                shellRoleCode = state.roleCode,
                shellSchoolLabel = state.schoolLabel,
                onChangeRole = { onEvent(HomeUiEvent.RolePickerRequested) },
                onLogout = onLogout
            )
        }
        return
    }
    if (state.selectedNavId == "students") {
        Box(
            modifier = modifier
                .fillMaxSize()
                .widthIn(max = contentWidth)
        ) {
            TeacherMyStudentsScreen(
                state = teacherMyStudentsUiState,
                onEvent = { event -> teacherMyStudentsViewModel?.onEvent(event) },
                onBack = { onEvent(HomeUiEvent.NavSelected("dashboard")) },
                shellRoleCode = state.roleCode,
                shellSchoolLabel = state.schoolLabel,
                onChangeRole = { onEvent(HomeUiEvent.RolePickerRequested) },
                onLogout = onLogout,
            )
        }
        return
    }
    if (state.selectedNavId == "student-records") {
        Box(
            modifier = modifier
                .fillMaxSize()
                .widthIn(max = contentWidth)
        ) {
            StudentsScreen(
                state = studentsUiState,
                onEvent = onStudentsEvent,
                shellRoleCode = state.roleCode,
                shellSchoolLabel = state.schoolLabel,
                onChangeRole = { onEvent(HomeUiEvent.RolePickerRequested) },
                onLogout = onLogout,
                headerActions = headerActions
            )
        }
        return
    }
    if (state.selectedNavId == "parents") {
        Box(
            modifier = modifier
                .fillMaxSize()
                .widthIn(max = contentWidth)
        ) {
            ParentsScreen(
                state = parentsUiState,
                onEvent = onParentsEvent,
                shellRoleCode = state.roleCode,
                shellSchoolLabel = state.schoolLabel,
                onChangeRole = { onEvent(HomeUiEvent.RolePickerRequested) },
                onLogout = onLogout,
                headerActions = headerActions
            )
        }
        return
    }
    if (state.selectedNavId == "classes") {
        Box(
            modifier = modifier
                .fillMaxSize()
                .widthIn(max = contentWidth)
        ) {
            ClassesScreen(
                state = classesUiState,
                onEvent = onClassesEvent,
                onBack = { onEvent(HomeUiEvent.NavSelected("dashboard")) },
                shellRoleCode = state.roleCode,
                onChangeRole = { onEvent(HomeUiEvent.RolePickerRequested) },
                onLogout = onLogout
            )
        }
        return
    }
    if (state.selectedNavId == "subjects") {
        Box(
            modifier = modifier
                .fillMaxSize()
                .widthIn(max = contentWidth)
        ) {
            SubjectsScreen(
                state = subjectsUiState,
                onEvent = onSubjectsEvent,
                onBack = { onEvent(HomeUiEvent.NavSelected("dashboard")) },
                shellRoleCode = state.roleCode,
                shellSchoolLabel = state.schoolLabel,
                onChangeRole = { onEvent(HomeUiEvent.RolePickerRequested) },
                onLogout = onLogout,
                headerActions = headerActions
            )
        }
        return
    }
    if (state.selectedNavId == "class-conversations") {
        Box(modifier = modifier.fillMaxSize().widthIn(max = contentWidth)) {
            AdminClassConversationsApiScreen(
                state = classConversationsUiState,
                onEvent = classConversationsViewModel?.let { vm -> vm::onEvent } ?: {},
                shellRoleCode = state.roleCode,
                onChangeRole = { onEvent(HomeUiEvent.RolePickerRequested) },
                onLogout = onLogout
            )
        }
        return
    }
    if (state.selectedNavId == "document-library") {
        Box(modifier = modifier.fillMaxSize().widthIn(max = contentWidth)) {
            DocumentLibraryScreen(
                uiState = documentLibraryUiState,
                onQueryChanged = documentLibraryViewModel?.let { { value -> it.onQueryChanged(value) } } ?: {},
                onCategoryChanged = documentLibraryViewModel?.let { { value -> it.onCategoryChanged(value) } } ?: {},
                onApplicableToChanged = documentLibraryViewModel?.let { { value -> it.onApplicableToChanged(value) } } ?: {},
                onClearFilters = documentLibraryViewModel?.let { it::clearFilters } ?: {},
                onPageChanged = documentLibraryViewModel?.let { { value -> it.onPageChanged(value) } } ?: {},
                onPageSizeChanged = documentLibraryViewModel?.let { { value -> it.onPageSizeChanged(value) } } ?: {},
                onSortChanged = documentLibraryViewModel?.let { { value -> it.onSortChanged(value) } } ?: {},
                onCreateDocument = documentLibraryViewModel?.let { vm -> { draft, onSuccess -> vm.createDocument(draft.title, draft.description, draft.category, draft.applicableTo, draft.filename, draft.contentType, draft.bytes, draft.classTargetIds) { if (it == null) onSuccess() } } } ?: { _, _ -> },
                onUpdateDocument = documentLibraryViewModel?.let { vm -> { id, title, description, category, applicableTo, classTargetIds, onSuccess -> vm.updateDocument(id, title, description, category, applicableTo, classTargetIds) { if (it == null) onSuccess() } } } ?: { _, _, _, _, _, _, _ -> },
                classOptions = documentLibraryUiState.classOptions,
                isLoadingClassOptions = documentLibraryUiState.isLoadingClassOptions,
                classOptionsError = documentLibraryUiState.classOptionsError,
                categoryOptions = documentLibraryUiState.categoryOptions,
                audienceOptions = documentLibraryUiState.audienceOptions,
                isLoadingLookupOptions = documentLibraryUiState.isLoadingLookupOptions,
                lookupOptionsError = documentLibraryUiState.lookupOptionsError,
                schoolLabel = state.schoolLabel,
                academicYearLabel = content.academicYearLabel,
                headerActions = headerActions,
                onLoadDocumentDetails = documentLibraryViewModel?.let { vm -> vm::loadDocumentDetails } ?: { _, _ -> },
                onDownload = documentLibraryViewModel?.let { vm -> vm::download } ?: {},
                onBack = { onEvent(HomeUiEvent.NavSelected("dashboard")) }
            )
        }
        return
    }
    if (state.selectedNavId == "support-center") {
        Box(modifier = modifier.fillMaxSize()) {
            SupportCenterScreen(
                schoolLabel = state.schoolLabel,
                roleCode = state.roleCode,
                roleLabel = state.roleLabel,
                onChangeRole = { onEvent(HomeUiEvent.RolePickerRequested) },
                onLogout = onLogout,
                onOpenDocumentLibrary = { onEvent(HomeUiEvent.NavSelected("document-library")) }
            )
        }
        return
    }
    Column(
        modifier = modifier
            .fillMaxSize()
            .padding(
                horizontal = 24.dp,
                vertical = 20.dp
            )
    ) {
        if (state.selectedNavId == "time-table") {
            TeacherTimeTableScreen(
                state = teacherTimeTableUiState,
                onEvent = { event -> teacherTimeTableViewModel?.onEvent(event) },
                headerActions = headerActions,
                contentHorizontalPadding = 0.dp,
                contentVerticalPadding = 0.dp,
                modifier = Modifier.fillMaxSize()
            )
        } else if (state.selectedNavId == "time-table-import") {
            Column(
                modifier = Modifier
                    .fillMaxWidth()
                    .align(Alignment.CenterHorizontally)
                    .weight(1f)
            ) {
                TimeTableScreen(
                    state = timeTableUiState,
                    onEvent = onTimeTableEvent,
                    schoolLabel = state.schoolLabel,
                    academicYearLabel = content.academicYearLabel,
                    headerActions = headerActions,
                    readOnly = state.selectedNavId == "time-table",
                    contentHorizontalPadding = 0.dp,
                    contentVerticalPadding = 0.dp,
                    modifier = Modifier.fillMaxSize()
                )
            }
        } else if (state.selectedNavId == "calendar") {
            Column(
                modifier = Modifier
                    .fillMaxWidth()
                    .widthIn(max = contentWidth)
                    .align(Alignment.CenterHorizontally)
                    .weight(1f)
            ) {
                CalendarScreen(
                    state = calendarUiState,
                    onEvent = onCalendarEvent,
                    onBack = { onEvent(HomeUiEvent.NavSelected("dashboard")) },
                    contextLine = "${state.schoolLabel} | ${content.academicYearLabel}",
                    headerActions = headerActions,
                    contentHorizontalPadding = 0.dp,
                    contentVerticalPadding = 0.dp,
                    modifier = Modifier.fillMaxSize()
                )
            }
        } else if (state.selectedNavId == "school-setup") {
            Column(
                modifier = Modifier
                    .fillMaxWidth()
                    .widthIn(max = contentWidth)
                    .align(Alignment.CenterHorizontally)
                    .weight(1f)
            ) {
                Box(
                    modifier = Modifier.fillMaxWidth()
                ) {
                    ImportsScreen(
                        state = importsUiState,
                        onEvent = onImportsEvent,
                        contextLine = "${state.schoolLabel} | ${content.academicYearLabel}",
                        headerActions = headerActions,
                        contentHorizontalPadding = 0.dp,
                        contentVerticalPadding = 0.dp,
                        modifier = Modifier.fillMaxSize()
                    )
                }
            }
        } else if (state.selectedNavId == "student-enrollment") {
            Column(
                modifier = Modifier
                    .fillMaxWidth()
                    .widthIn(max = contentWidth)
                    .weight(1f)
            ) {
                StudentEnrollmentScreen(
                    state = studentEnrollmentUiState,
                    onEvent = onStudentEnrollmentEvent,
                    contextLine = "${state.schoolLabel} | ${content.academicYearLabel}",
                    headerActions = headerActions,
                    contentHorizontalPadding = 0.dp,
                    contentTopPadding = 0.dp,
                    contentBottomPadding = 0.dp
                )
            }
        } else if (state.selectedNavId == "analytics-reports") {
            Box(Modifier.fillMaxWidth().widthIn(max = contentWidth).align(Alignment.CenterHorizontally)) {
                SchoolAdminHeader(
                    state = state,
                    content = content,
                    onEvent = onEvent,
                    onLogout = onLogout,
                    onEditProfile = onEditProfile,
                    title = "Reports & Analytics",
                    subtitle = "View attendance, academic performance and activity reports."
                )
            }
            Spacer(Modifier.height(14.dp))
            StaffPerformanceReportsScreen(
                isTeacher = false,
                schoolId = state.schoolId,
                activeAcademicYearId = state.activeAcademicYearId,
                modifier = Modifier.fillMaxWidth().widthIn(max = contentWidth).align(Alignment.CenterHorizontally).weight(1f)
            )
            Spacer(Modifier.height(10.dp))
        } else {
            Box(
                modifier = Modifier
                    .fillMaxWidth()
                    .widthIn(max = contentWidth)
            ) {
                SchoolAdminHeader(
                    state = state,
                    content = content,
                    onEvent = onEvent,
                    onLogout = onLogout,
                    onEditProfile = onEditProfile
                )
            }

            Spacer(modifier = Modifier.height(14.dp))

            Column(
                modifier = Modifier
                    .fillMaxWidth()
                    .widthIn(max = contentWidth)
                    .align(Alignment.CenterHorizontally)
                    .weight(1f)
            ) {
                Column(
                    modifier = Modifier
                        .fillMaxSize()
                        .verticalScroll(scrollState),
                    verticalArrangement = Arrangement.spacedBy(18.dp)
                ) {
                    Box(modifier = Modifier.fillMaxWidth()) {
                        if (state.isSchoolStatisticsLoading) {
                            SchoolAdminStatGridShimmer(compactLayout = compactLayout)
                        } else if (content.statCards.isEmpty()) {
                            SchoolAdminSurfaceCard(modifier = Modifier.fillMaxWidth()) {
                                Box(
                                    modifier = Modifier
                                        .fillMaxWidth()
                                        .padding(horizontal = 24.dp, vertical = 28.dp),
                                    contentAlignment = Alignment.Center
                                ) {
                                    AdminListEmptyState(
                                        title = "Dashboard data unavailable",
                                        subtitle = "We could not load school analytics right now."
                                    )
                                }
                            }
                        } else {
                            SchoolAdminStatGrid(
                                statCards = content.statCards,
                                compactLayout = compactLayout
                            )
                        }
                    }

                    Box(modifier = Modifier.fillMaxWidth()) {
                        SchoolAdminNoticeAndEventsSection(
                            notices = content.notices,
                            events = content.events,
                            isLoading = state.isSchoolDashboardEventsNoticesLoading,
                            compactLayout = compactLayout,
                            onNavigate = { onEvent(HomeUiEvent.NavSelected(it)) }
                        )
                    }
                }
            }

            Spacer(modifier = Modifier.height(10.dp))

        }
    }
}

@Composable
internal fun SchoolAdminHeader(
    state: HomeUiState,
    content: SchoolAdminDashboardContent,
    onEvent: (HomeUiEvent) -> Unit,
    onLogout: () -> Unit,
    onEditProfile: () -> Unit,
    title: String = "Hello, ${state.userProfile.fullName.ifBlank { state.roleLabel }}",
    subtitle: String = "${state.schoolLabel}  |  ${content.academicYearLabel}",
    detailText: String = ""
) {
    ShellPageHeader(
        title = title,
        subtitle = subtitle,
        detailText = detailText,
        titleColor = AppPageHeader,
        subtitleColor = AppPageSubtitle,
        detailColor = SchoolAdminMuted,
        headerActions = {
            ShellTopRightActions(
                roleLabel = state.roleLabel,
                roleSubtitle = state.roleSubtitle,
                initials = shellAvatarInitials(state.userProfile.fullName.ifBlank { state.roleLabel }),
                expanded = state.isAccountMenuExpanded,
                onExpandedChange = { expanded ->
                    onEvent(if (expanded) HomeUiEvent.AccountMenuToggled else HomeUiEvent.AccountMenuDismissed)
                },
                onChangeRole = { onEvent(HomeUiEvent.RolePickerRequested) },
                onLogout = onLogout,
                onMyProfile = onEditProfile,
                profileName = state.userProfile.fullName,
                profileEmail = state.userProfile.email
            )
        }
    )
}

@Composable
private fun SchoolAdminStatGrid(
    statCards: List<SchoolAdminStatCardData>,
    compactLayout: Boolean
) {
    if (compactLayout) {
        Column(verticalArrangement = Arrangement.spacedBy(14.dp)) {
            statCards.forEach { card ->
                SchoolAdminStatCard(
                    card = card,
                    modifier = Modifier.fillMaxWidth()
                )
            }
        }
    } else {
        Column(verticalArrangement = Arrangement.spacedBy(14.dp)) {
            statCards.chunked(5).forEach { rowCards ->
                Row(
                    modifier = Modifier
                        .fillMaxWidth()
                        .heightIn(min = 160.dp),
                    horizontalArrangement = Arrangement.spacedBy(12.dp)
                ) {
                    rowCards.forEach { card ->
                        SchoolAdminStatCard(
                            card = card,
                            modifier = Modifier.weight(1f)
                        )
                    }
                }
            }
        }
    }
}

@Composable
private fun SchoolAdminStatCard(
    card: SchoolAdminStatCardData,
    modifier: Modifier = Modifier
) {
    AdminListStatCardShell(
        modifier = modifier,
        surfaceColor = SchoolAdminCard,
        borderColor = SchoolAdminBorder,
        minHeight = 160.dp,
        contentPadding = androidx.compose.foundation.layout.PaddingValues(14.dp)
    ) {
        Column(
            modifier = Modifier
                .fillMaxWidth()
                .padding(0.dp),
            verticalArrangement = Arrangement.spacedBy(12.dp)
        ) {
            Row(
                verticalAlignment = Alignment.CenterVertically,
                horizontalArrangement = Arrangement.spacedBy(12.dp)
            ) {
                Box(
                    modifier = Modifier
                        .size(54.dp)
                        .clip(CircleShape)
                        .background(card.accentSoft),
                    contentAlignment = Alignment.Center
                ) {
                    Icon(
                        painter = homeIconPainter(card.icon),
                        contentDescription = card.title,
                        tint = card.accent,
                        modifier = Modifier.size(26.dp)
                    )
                }
                Column(verticalArrangement = Arrangement.spacedBy(4.dp)) {
                    Text(
                        text = card.title,
                        style = MaterialTheme.typography.titleMedium,
                        fontWeight = FontWeight.Bold,
                        color = SchoolAdminNavy
                    )
                    Text(
                        text = card.value,
                        style = MaterialTheme.typography.headlineSmall,
                        fontWeight = FontWeight.Bold,
                        color = card.accent
                    )
                }
            }
            HorizontalDivider(color = card.accentSoft)
            Row(
                modifier = Modifier.fillMaxWidth(),
                horizontalArrangement = Arrangement.SpaceBetween,
                verticalAlignment = Alignment.CenterVertically
            ) {
                card.breakdown.forEachIndexed { index, section ->
                    Column(
                        modifier = Modifier.weight(1f),
                        verticalArrangement = Arrangement.spacedBy(6.dp),
                        horizontalAlignment = Alignment.CenterHorizontally
                    ) {
                        Text(
                            text = section.title,
                            style = MaterialTheme.typography.bodySmall,
                            color = SchoolAdminNavy,
                            fontWeight = FontWeight.SemiBold,
                            maxLines = 1,
                            overflow = TextOverflow.Ellipsis
                        )
                        Text(
                            text = section.value,
                            style = MaterialTheme.typography.titleLarge,
                            color = card.accent,
                            fontWeight = FontWeight.Bold
                        )
                    }
                    if (index != card.breakdown.lastIndex) {
                        Box(
                            modifier = Modifier
                                .width(1.dp)
                                .height(36.dp)
                                .background(SchoolAdminBorder)
                        )
                    }
                }
            }
        }
    }
}

@Composable
private fun SchoolAdminStatGridShimmer(
    compactLayout: Boolean
) {
    val placeholderCount = 5
    if (compactLayout) {
        Column(verticalArrangement = Arrangement.spacedBy(14.dp)) {
            repeat(placeholderCount) {
                SchoolAdminStatCardShimmer(
                    modifier = Modifier.fillMaxWidth()
                )
            }
        }
    } else {
        Column(verticalArrangement = Arrangement.spacedBy(14.dp)) {
            List(placeholderCount) { it }.chunked(5).forEach { rowCards ->
                Row(
                    modifier = Modifier
                        .fillMaxWidth()
                        .heightIn(min = 160.dp),
                    horizontalArrangement = Arrangement.spacedBy(12.dp)
                ) {
                    rowCards.forEach {
                        SchoolAdminStatCardShimmer(
                            modifier = Modifier.weight(1f)
                        )
                    }
                }
            }
        }
    }
}

@Composable
private fun SchoolAdminStatCardShimmer(
    modifier: Modifier = Modifier
) {
    val transition = rememberInfiniteTransition(label = "school_admin_stat_shimmer")
    val shimmerX by transition.animateFloat(
        initialValue = -420f,
        targetValue = 1440f,
        animationSpec = infiniteRepeatable(
            animation = tween(durationMillis = 1200, easing = LinearEasing),
            repeatMode = RepeatMode.Restart
        ),
        label = "school_admin_stat_shimmer_x"
    )
    val shimmerBrush = Brush.linearGradient(
        colors = listOf(
            Color(0xFFE4EAF7),
            Color(0xFFF9FBFF),
            Color(0xFFE4EAF7)
        ),
        start = Offset(shimmerX, shimmerX),
        end = Offset(shimmerX + 240f, shimmerX + 240f)
    )

    AdminListStatCardShell(
        modifier = modifier,
        surfaceColor = SchoolAdminCard,
        borderColor = SchoolAdminBorder,
        minHeight = 160.dp,
        contentPadding = androidx.compose.foundation.layout.PaddingValues(14.dp)
    ) {
        Column(
            modifier = Modifier.fillMaxWidth(),
            verticalArrangement = Arrangement.spacedBy(12.dp)
        ) {
            Row(
                verticalAlignment = Alignment.CenterVertically,
                horizontalArrangement = Arrangement.spacedBy(12.dp)
            ) {
                Box(
                    modifier = Modifier
                        .size(54.dp)
                        .clip(CircleShape)
                        .background(shimmerBrush)
                )
                Column(verticalArrangement = Arrangement.spacedBy(6.dp)) {
                    Box(
                        modifier = Modifier
                            .width(80.dp)
                            .height(14.dp)
                            .clip(RoundedCornerShape(8.dp))
                            .background(shimmerBrush)
                    )
                    Box(
                        modifier = Modifier
                            .width(60.dp)
                            .height(26.dp)
                            .clip(RoundedCornerShape(8.dp))
                            .background(shimmerBrush)
                    )
                }
            }
            HorizontalDivider(color = SchoolAdminBorder)
            Row(
                modifier = Modifier.fillMaxWidth(),
                horizontalArrangement = Arrangement.SpaceBetween,
                verticalAlignment = Alignment.CenterVertically
            ) {
                repeat(2) { index ->
                    Column(
                        modifier = Modifier.weight(1f),
                        verticalArrangement = Arrangement.spacedBy(4.dp),
                        horizontalAlignment = Alignment.CenterHorizontally
                    ) {
                        Box(
                            modifier = Modifier
                                .width(70.dp)
                                .height(10.dp)
                                .clip(RoundedCornerShape(8.dp))
                                .background(shimmerBrush)
                        )
                        Box(
                            modifier = Modifier
                                .width(48.dp)
                                .height(16.dp)
                                .clip(RoundedCornerShape(8.dp))
                                .background(shimmerBrush)
                        )
                    }
                    if (index != 1) {
                        Box(
                            modifier = Modifier
                                .width(1.dp)
                                .height(36.dp)
                                .background(SchoolAdminBorder)
                        )
                    }
                }
            }
        }
    }
}

@Composable
private fun SchoolAdminNoticeAndEventsSection(
    notices: List<SchoolAdminFeedItem>,
    events: List<SchoolAdminFeedItem>,
    isLoading: Boolean,
    compactLayout: Boolean,
    onNavigate: (String) -> Unit
) {
    if (compactLayout) {
        Column(verticalArrangement = Arrangement.spacedBy(16.dp)) {
            if (isLoading) {
                SchoolAdminFeedPanelShimmer(
                    title = "Recent Notices",
                    compactLayout = true,
                    modifier = Modifier.fillMaxWidth()
                )
                SchoolAdminFeedPanelShimmer(
                    title = "Upcoming Events",
                    compactLayout = true,
                    modifier = Modifier.fillMaxWidth()
                )
            } else {
                SchoolAdminNoticePanel(
                    notices = notices,
                    onNavigate = onNavigate,
                    modifier = Modifier.fillMaxWidth()
                )
                SchoolAdminEventsPanel(
                    events = events,
                    onNavigate = onNavigate,
                    modifier = Modifier.fillMaxWidth()
                )
            }
        }
    } else {
        Row(
            modifier = Modifier
                .fillMaxWidth()
                .height(IntrinsicSize.Min),
            horizontalArrangement = Arrangement.spacedBy(16.dp)
        ) {
            if (isLoading) {
                SchoolAdminFeedPanelShimmer(
                    title = "Recent Notices",
                    compactLayout = false,
                    modifier = Modifier
                        .weight(1f)
                        .fillMaxHeight()
                )
                SchoolAdminFeedPanelShimmer(
                    title = "Upcoming Events",
                    compactLayout = false,
                    modifier = Modifier
                        .weight(1f)
                        .fillMaxHeight()
                )
            } else {
                SchoolAdminNoticePanel(
                    notices = notices,
                    onNavigate = onNavigate,
                    modifier = Modifier
                        .weight(1f)
                        .fillMaxHeight()
                )
                SchoolAdminEventsPanel(
                    events = events,
                    onNavigate = onNavigate,
                    modifier = Modifier
                        .weight(1f)
                        .fillMaxHeight()
                )
            }
        }
    }
}

@Composable
private fun SchoolAdminNoticePanel(
    notices: List<SchoolAdminFeedItem>,
    onNavigate: (String) -> Unit,
    modifier: Modifier = Modifier
) {
    SchoolAdminSurfaceCard(modifier = modifier) {
        Column(modifier = Modifier.fillMaxWidth().fillMaxHeight()) {
            SchoolAdminPanelHeader(title = "Recent Notices")
            if (notices.isEmpty()) {
                Box(
                    modifier = Modifier
                        .fillMaxWidth()
                        .weight(1f),
                    contentAlignment = Alignment.Center
                ) {
                    AdminListEmptyState(
                        title = "No notices yet",
                        subtitle = "Recent notices will appear here once published."
                    )
                }
            } else {
                notices.forEachIndexed { index, notice ->
                    if (index > 0) {
                        HorizontalDivider(color = SchoolAdminBorder)
                    }
                    SchoolAdminNoticeRow(item = notice)
                }
            }
            Spacer(modifier = Modifier.weight(1f))
            HorizontalDivider(color = SchoolAdminBorder)
            Row(
                modifier = Modifier
                    .fillMaxWidth()
                    .clickable { onNavigate("notices") }
                    .padding(horizontal = 18.dp, vertical = 14.dp),
                horizontalArrangement = Arrangement.spacedBy(8.dp),
                verticalAlignment = Alignment.CenterVertically
            ) {
                Text(
                    text = "View All Notices",
                    style = MaterialTheme.typography.titleSmall,
                    color = SchoolAdminBlue,
                    fontWeight = FontWeight.SemiBold
                )
                Icon(
                    painter = homeIconPainter("arrow_right"),
                    contentDescription = null,
                    tint = SchoolAdminBlue,
                    modifier = Modifier.size(16.dp)
                )
            }
        }
    }
}

@Composable
private fun SchoolAdminEventsPanel(
    events: List<SchoolAdminFeedItem>,
    onNavigate: (String) -> Unit,
    modifier: Modifier = Modifier
) {
    SchoolAdminSurfaceCard(modifier = modifier) {
        Column(modifier = Modifier.fillMaxWidth().fillMaxHeight()) {
            SchoolAdminPanelHeader(title = "Upcoming Events")
            if (events.isEmpty()) {
                Box(
                    modifier = Modifier
                        .fillMaxWidth()
                        .weight(1f),
                    contentAlignment = Alignment.Center
                ) {
                    AdminListEmptyState(
                        title = "No events yet",
                        subtitle = "Upcoming events will appear here once scheduled."
                    )
                }
            } else {
                events.forEachIndexed { index, event ->
                    if (index > 0) {
                        HorizontalDivider(color = SchoolAdminBorder)
                    }
                    SchoolAdminEventRow(item = event)
                }
            }
            Spacer(modifier = Modifier.weight(1f))
            HorizontalDivider(color = SchoolAdminBorder)
            Row(
                modifier = Modifier
                    .fillMaxWidth()
                    .clickable { onNavigate("events-news") }
                    .padding(horizontal = 18.dp, vertical = 14.dp),
                horizontalArrangement = Arrangement.spacedBy(8.dp),
                verticalAlignment = Alignment.CenterVertically
            ) {
                Text(
                    text = "View All Events",
                    style = MaterialTheme.typography.titleSmall,
                    color = SchoolAdminBlue,
                    fontWeight = FontWeight.SemiBold
                )
                Icon(
                    painter = homeIconPainter("arrow_right"),
                    contentDescription = null,
                    tint = SchoolAdminBlue,
                    modifier = Modifier.size(16.dp)
                )
            }
        }
    }
}

@Composable
private fun SchoolAdminFeedPanelShimmer(
    title: String,
    actionLabel: String? = null,
    compactLayout: Boolean,
    modifier: Modifier = Modifier
) {
    val placeholderCount = 5
    val transition = rememberInfiniteTransition(label = "school_admin_feed_shimmer")
    val shimmerX by transition.animateFloat(
        initialValue = -420f,
        targetValue = 1440f,
        animationSpec = infiniteRepeatable(
            animation = tween(durationMillis = 1200, easing = LinearEasing),
            repeatMode = RepeatMode.Restart
        ),
        label = "school_admin_feed_shimmer_x"
    )
    val shimmerBrush = Brush.linearGradient(
        colors = listOf(
            Color(0xFFE4EAF7),
            Color(0xFFF9FBFF),
            Color(0xFFE4EAF7)
        ),
        start = Offset(shimmerX, shimmerX),
        end = Offset(shimmerX + 240f, shimmerX + 240f)
    )

    SchoolAdminSurfaceCard(modifier = modifier) {
        Column(modifier = Modifier.fillMaxWidth().fillMaxHeight()) {
            SchoolAdminPanelHeader(title = title, actionLabel = actionLabel)
            repeat(placeholderCount) { index ->
                if (index > 0) {
                    HorizontalDivider(color = SchoolAdminBorder)
                }
                if (compactLayout) {
                    SchoolAdminNoticeShimmerRow(shimmerBrush = shimmerBrush)
                } else {
                    SchoolAdminNoticeShimmerRow(shimmerBrush = shimmerBrush)
                }
            }
            Spacer(modifier = Modifier.weight(1f))
            HorizontalDivider(color = SchoolAdminBorder)
            Row(
                modifier = Modifier
                    .fillMaxWidth()
                    .padding(horizontal = 18.dp, vertical = 14.dp),
                horizontalArrangement = Arrangement.spacedBy(8.dp),
                verticalAlignment = Alignment.CenterVertically
            ) {
                Box(
                    modifier = Modifier
                        .width(118.dp)
                        .height(16.dp)
                        .clip(RoundedCornerShape(8.dp))
                        .background(shimmerBrush)
                )
                Spacer(modifier = Modifier.width(8.dp))
                Box(
                    modifier = Modifier
                        .size(16.dp)
                        .clip(CircleShape)
                        .background(shimmerBrush)
                )
            }
        }
    }
}

@Composable
private fun SchoolAdminNoticeShimmerRow(
    shimmerBrush: Brush
) {
    Row(
        modifier = Modifier
            .fillMaxWidth()
            .padding(horizontal = 18.dp, vertical = 13.dp),
        verticalAlignment = Alignment.CenterVertically
    ) {
        Box(
            modifier = Modifier
                .size(34.dp)
                .clip(RoundedCornerShape(8.dp))
                .background(shimmerBrush)
        )
        Spacer(modifier = Modifier.width(14.dp))
        Column(
            modifier = Modifier.weight(1f),
            verticalArrangement = Arrangement.spacedBy(6.dp)
        ) {
            Box(
                modifier = Modifier
                    .width(220.dp)
                    .height(14.dp)
                    .clip(RoundedCornerShape(8.dp))
                    .background(shimmerBrush)
            )
            Box(
                modifier = Modifier
                    .width(280.dp)
                    .height(11.dp)
                    .clip(RoundedCornerShape(8.dp))
                    .background(shimmerBrush)
            )
        }
        Spacer(modifier = Modifier.width(12.dp))
        Box(
            modifier = Modifier
                .width(82.dp)
                .height(14.dp)
                .clip(RoundedCornerShape(8.dp))
                .background(shimmerBrush)
        )
    }
}

@Composable
private fun SchoolAdminNoticeRow(item: SchoolAdminFeedItem) {
    Row(
        modifier = Modifier
            .fillMaxWidth()
            .padding(horizontal = 18.dp, vertical = 13.dp),
        verticalAlignment = Alignment.CenterVertically
    ) {
        Box(
            modifier = Modifier
                .size(34.dp)
                .clip(RoundedCornerShape(8.dp))
                .background(item.iconBg),
            contentAlignment = Alignment.Center
        ) {
            Icon(
                painter = homeIconPainter(item.icon),
                contentDescription = null,
                tint = item.iconTint,
                modifier = Modifier.size(18.dp)
            )
        }
        Spacer(modifier = Modifier.width(14.dp))
        Column(
            modifier = Modifier.weight(1f),
            verticalArrangement = Arrangement.spacedBy(2.dp)
        ) {
            Text(
                text = item.title,
                style = MaterialTheme.typography.bodyMedium,
                color = SchoolAdminNavy,
                fontWeight = FontWeight.Medium,
                maxLines = 1,
                overflow = TextOverflow.Ellipsis
            )
            Text(
                text = item.subtitle,
                style = MaterialTheme.typography.bodySmall,
                color = SchoolAdminMuted,
                maxLines = 1,
                overflow = TextOverflow.Ellipsis
            )
        }
        Spacer(modifier = Modifier.width(12.dp))
        Text(
            text = item.trailingLabel,
            style = MaterialTheme.typography.bodyMedium,
            color = SchoolAdminMuted
        )
    }
}

@Composable
private fun SchoolAdminEventRow(item: SchoolAdminFeedItem) {
    Row(
        modifier = Modifier
            .fillMaxWidth()
            .padding(horizontal = 18.dp, vertical = 13.dp),
        verticalAlignment = Alignment.CenterVertically
    ) {
        Column(
            modifier = Modifier
                .size(46.dp)
                .clip(RoundedCornerShape(10.dp))
                .background(item.dateBg),
            verticalArrangement = Arrangement.Center,
            horizontalAlignment = Alignment.CenterHorizontally
        ) {
            Text(
                text = item.dateDay,
                style = MaterialTheme.typography.titleMedium,
                color = item.dateTint,
                fontWeight = FontWeight.Bold
            )
            Text(
                text = item.dateMonth,
                style = MaterialTheme.typography.labelSmall,
                color = item.dateTint,
                fontWeight = FontWeight.SemiBold
            )
        }
        Spacer(modifier = Modifier.width(14.dp))
        Column(
            modifier = Modifier.weight(1f),
            verticalArrangement = Arrangement.spacedBy(3.dp)
        ) {
            Text(
                text = item.title,
                style = MaterialTheme.typography.bodyMedium,
                color = SchoolAdminNavy,
                fontWeight = FontWeight.Bold,
                maxLines = 1,
                overflow = TextOverflow.Ellipsis
            )
            Text(
                text = item.subtitle,
                style = MaterialTheme.typography.bodySmall,
                color = SchoolAdminMuted,
                maxLines = 1,
                overflow = TextOverflow.Ellipsis
            )
        }
        Spacer(modifier = Modifier.width(12.dp))
        Text(
            text = item.trailingLabel,
            style = MaterialTheme.typography.bodyMedium,
            color = SchoolAdminMuted
        )
    }
}

@Composable
private fun SchoolAdminPanelHeader(
    title: String,
    actionLabel: String? = null
) {
    AdminListPanelHeader(
        title = title,
        actionLabel = actionLabel,
        horizontalPadding = 18.dp,
        verticalPadding = 14.dp,
        titleColor = AppPageHeader,
        actionColor = SchoolAdminBlue,
        actionFontSize = 13.sp
    )
}

@Composable
private fun SchoolAdminSurfaceCard(
    modifier: Modifier = Modifier,
    content: @Composable () -> Unit
) {
    Card(
        modifier = modifier,
        shape = RoundedCornerShape(20.dp),
        colors = CardDefaults.cardColors(containerColor = SchoolAdminCard),
        border = androidx.compose.foundation.BorderStroke(1.dp, SchoolAdminBorder),
        elevation = CardDefaults.cardElevation(defaultElevation = 2.dp)
    ) {
        content()
    }
}
